import { instance } from '@/services/avik-api-gateway'
import { AxiosResponse } from 'axios'
import { Role } from '@/types/role'

export function getRoles(): Promise<AxiosResponse<Role[]>> {
  return instance.get(`/iam/role`)
}
